<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="selected"
    class="color-picker"
    lazy
    max-width="max-content"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="selected"
        v-bind="$attrs"
        v-on="on"
      />
    </template>
    <v-card>
      <v-card-text>
        <chrome
          v-model="selected"
          class="mx-auto"
          @input="selected = $event.hex"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn
          block
          flat
          color="primary"
          @click="erase()">
          {{ $t('Erase') }}
        </v-btn>

        <v-spacer/>

        <v-btn
          block
          flat
          color="primary"
          @click="$refs.dialog.save(selected); $emit('change')">
          {{ $t('Confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Chrome } from 'vue-color'

export default {
  name: 'ColorPicker',

  components: {
    Chrome
  },

  props: {
    value: {
      validator: value => {
        return value === null || typeof value === 'string'
      },
      default: '#FFFFFF'
    }
  },

  data () {
    return {
      modal: false
    }
  },

  computed: {
    selected: {
      get () {
        return this.value || '#FFFFFF'
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    erase () {
      this.selected = null
      this.$refs.dialog.save(null)
      this.$emit('change')
    }
  }
}
</script>
